module.exports = __webpack_public_path__ + "static/media/25_potolok_14.01_0.634b827f.png";